module.exports = __webpack_public_path__ + "static/media/jiasu.4cc4608f.png";